import { QueryKeys } from '@shared/domain/queryKeys'
import { useApiClient } from '@shared/hooks/useApiClient'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { Bet, BetStatus } from '../domain/Bet.domain'

interface CreateBetInput {
  thesis: string
  categoryId: string
  ownerId: string
  status: BetStatus
}

export const useCreateBet = () => {
  const api = useApiClient()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: CreateBetInput) => {
      const response = await api.post<Bet>('/bets', data)
      return response.data
    },
    onSuccess: (newBet) => {
      queryClient.setQueryData<Bet[]>([QueryKeys.Bets], (old = []) => [
        ...old,
        newBet,
      ])
    },
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: [QueryKeys.Bets] })
    },
  })
}
